/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  EthereumDistribute,
  EthereumDistributeInterface,
} from "../EthereumDistribute";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_ethereumOMIAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "fromChain",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "toChain",
        type: "string",
      },
    ],
    name: "Distribute",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "previousFee",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "FeeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "FeePaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousFeeReceiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newFeeReceiver",
        type: "address",
      },
    ],
    name: "FeeReceiverChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ethereumOMIAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
    ],
    name: "getHasPaidFee",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
    ],
    name: "payFee",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "newFeeReceiver",
        type: "address",
      },
    ],
    name: "setFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
    ],
    name: "getHasDistributed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class EthereumDistribute__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _ethereumOMIAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<EthereumDistribute> {
    return super.deploy(_ethereumOMIAddress, overrides || {}) as Promise<
      EthereumDistribute
    >;
  }
  getDeployTransaction(
    _ethereumOMIAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_ethereumOMIAddress, overrides || {});
  }
  attach(address: string): EthereumDistribute {
    return super.attach(address) as EthereumDistribute;
  }
  connect(signer: Signer): EthereumDistribute__factory {
    return super.connect(signer) as EthereumDistribute__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EthereumDistributeInterface {
    return new utils.Interface(_abi) as EthereumDistributeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EthereumDistribute {
    return new Contract(address, _abi, signerOrProvider) as EthereumDistribute;
  }
}
